import { render } from "./CampanasServicios.vue?vue&type=template&id=7380e121&scoped=true"
import script from "./CampanasServicios.vue?vue&type=script&lang=js"
export * from "./CampanasServicios.vue?vue&type=script&lang=js"

import "./CampanasServicios.vue?vue&type=style&index=0&id=7380e121&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7380e121"]])

export default __exports__